import React from 'react';
import EntitiesList from '../home/EntitiesList';
import TerritoryStats from '../../common/Stats/Territory';
import VendorsWidget from '../home/VendorsWidget';

const MemoEntitiesList = React.memo(EntitiesList);
const MemoTerritoryStats = React.memo(TerritoryStats);
const MemoVendorsWidget = React.memo(VendorsWidget);

const renderWidget = (metric, entity, sharedMode) => {
	const { entity: entityType, id, dateStart, dateEnd } = entity;

	switch (metric) {
		case 'products':
			return <MemoEntitiesList key={id} trends={true} title="Top Products" entity="products" dateStart={dateStart} dateEnd={dateEnd} prevDateStart={null} prevDateEnd={null} parentEntity={entityType} parentEntityIDs={id} addTotal={true} externalLinks={!sharedMode} />;
		case 'artists':
			return <MemoEntitiesList key={id} trends={true} title="Top Artists" entity="artists" dateStart={dateStart} dateEnd={dateEnd} prevDateStart={null} prevDateEnd={null} parentEntity={entityType} parentEntityIDs={id} addTotal={true} externalLinks={!sharedMode} />;
		case 'tracks':
			return <MemoEntitiesList key={id} trends={true} title="Top Tracks" entity="tracks" dateStart={dateStart} dateEnd={dateEnd} prevDateStart={null} prevDateEnd={null} parentEntity={entityType} parentEntityIDs={id} externalLinks={!sharedMode} />;
		case 'territories':
			return <MemoTerritoryStats key={id} dateStart={dateStart} dateEnd={dateEnd} prevDateStart={null} prevDateEnd={null} entity={entityType} ids={id} comparison={true} />;
		case 'vendors':
			return <MemoVendorsWidget key={id} dateStart={dateStart} dateEnd={dateEnd} prevDateStart={null} prevDateEnd={null} entity={entityType} id={id} comparison={true} />;
		default:
			return null;
	}
};

const ComparisonRow = ({ entities, metric, sharedMode }) => (
	<div className={`comparison-row comparison-row-${metric}`}>
		{entities.map(entity => renderWidget(metric, entity, sharedMode))}
	</div>
);

export default ComparisonRow;